import Swiper from 'swiper/bundle';

$(document).ready(() => {
    if (jQuery('.featured__slider').length) {
        const swiper = new Swiper(".featured__slider", {
            loop: true,
            autoHeight: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });
    }
});